import { Step } from "react-joyride";

export const tourStepsTypingSimulator = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.mb-8",
      content:
        "Typing Simulator shows a passage on screen. Type it as you see it. Letters turn green when they match.",
      disableBeacon: true,
    },
    {
      target: ".game-instructions",
      content:
        "Pick a sample passage, a saved one, or Write your own. Custom passages can be named and saved for later.",
    },
    {
      target: "#passageSelect",
      content:
        "This menu chooses the text. After you pick one, a preview appears below so you can check it before starting.",
    },
    {
      target: ".start-button",
      content:
        "Click Start Typing, then type in the box. You will see speed and accuracy when you finish.",
    },
  ];

  return steps;
};
